<template>
  <div class="one-too-many-input">
    <h4 class="form_title">{{ label }}</h4>
    <table class="">
      <thead v-if="model.length">
        <th v-for="header in headers" :key="header.name">
          {{ header.name }}
        </th>
      </thead>
      <tbody>
        <tr v-for="(entry, index) in model" :key="index" :id="'row_'+index">
          <td v-for="header in headers" :key="header.key">
            <select 
              v-if="header.type == 'select'" 
              :id="header.key" 
              :type="header.type" 
              :required="header.required"  
              v-model="entry[header.key]" 
              @input="handleInput"
            ><option v-for="option in header.options" :key="option">
                {{ option }}
              </option>
            </select>
            <input v-else 
              :id="header.key" 
              :type="header.type" 
              :required="header.required" 
              v-model="entry[header.key]" 
              @input="handleInput"
            >
          </td>
          <td>
            <button @click.stop.prevent="removeRow($event)" class="cg-btn" :data-rowid="'row_'+index">
              Supprimer
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button @click.stop.prevent="addRow($event)">+ Ajouter</button>
  </div>
</template>

<script>
export default {
  name: 'OneToManyFormInput',
  props: {
    type: String,
    headers: Array,
    label: String,
    model: Array
  },
  data: function () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    addRow (event) {
      const entry = {}
      for (var header of this.headers) {
        entry[header.key] = ''
      }
      this.model.push(entry)
    },
    removeRow (event) {
      this.model.splice(event.target.dataset.rowid.substring(4), 1)
      event.stopPropagation()
      event.preventDefault()
    },
    handleInput ($event) {
      this.$emit('input', this.model)
    }
  }
}
</script>

<style lang="scss" scoped>
.one-too-many-input {

  table {
    width: 100%;
  }

  input, select {
    border: none;
    border-bottom: solid 1px #ddd;
    height: 46px;
    width: 100%;
    margin: 4px;
    background: transparent;
  }
  input[type=checkbox] {
    height: 20px;
    width: 20px;
    border-radius: 3px;
  }

  button {
    width: 100%;
    height: 40px;
    background-color: white;
    border: solid 1px #aaabac;
    border-radius: 5px;
    font-weight: 600;
    color: #aaabac;
  }
 
.form_title {
  font-size: 1.3rem;
  font-weight: normal;
  margin: 16px 0;
}
}
</style>
